/*
login-api.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('loginApi',['angular', 'messages'], function () {

    // Module Dependencies
    var dependencies = [
        'Services.Messages'
    ];

    // Module Definition
    var mod = angular.module('Services.LoginApi', dependencies);

    /**
     * @name loginApi
     * @type factory
     *
     * @description
     * A factory that provides methods for making requests to the login REST API.
     */
    mod.factory('loginApi', ['$q', '$log', 'messages', '$window', function ($q, $log, messages) {
        /**
         * Base url for requests to the login REST API.
         */
        var LOGIN_URL = '/login/';
        var GET_USERDETAILS_URL = "/v1/umgmt/guest/users/getuserdetails";
        var selectedOrg = '';
        /**
         * Public API
         */
        return {
            // POST
            loginUser: loginUser,
            getUserData: getUserData,
            applicationLogout: applicationLogout,
            getSSOEnable: getSSOEnable,
            getCustomizeLogoInfo: getCustomizeLogoInfo,
            isSecondFactAuthEnabled: isSecondFactAuthEnabled,
            getOrganizationNameFromSession:  getOrganizationNameFromSession
        };

        /**
         * Attempts to login a user account.
         *
         * @param data.username
         *    The username of the account to login.
         *
         * @param data.password
         *    The password of the account to login.
         *
         * @param data.targetUrl
         *    TODO(Eric): Provide a description for this parameter.
         *
         * @param data.rememberme
         *    True if the user wishes to have their credentials remembered. False otherwise.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function loginUser(data, settings) {
            // Validate arguments
            if (isParameterFalseOrEmpty(data.username)) {
                var usernameErrorMsg = 'Error: loginApi: loginUser: invalid parameter: data.username = ' + data.username;
                $log.error(usernameErrorMsg);
                return $q.reject(messages.get('serviceResponseFailure'));
            }
            if (isParameterFalseOrEmpty(data.password)) {
                var passwordErrorMsg = 'Error: loginApi: loginUser: invalid parameter: data.password = ' + data.password;
                $log.error(passwordErrorMsg);
                return $q.reject(messages.get('serviceResponseFailure'));
            }
            if (angular.isString(data.targetUrl) === false) {
                var invalidParameterErrorMsg = 'Error: loginApi: loginUser: invalid parameter: data.targetUrl = ' + data.targetUrl;
                $log.error(invalidParameterErrorMsg);
                return $q.reject(messages.get('serviceResponseFailure'));
            }
            if (isParameterNotTrueAndNotFalse(data.rememberme)) {
                var remembermeErrorMsg = 'Error: loginApi: loginUser: invalid parameter: data.rememberme = ' + data.rememberme;
                $log.error(remembermeErrorMsg);
                return $q.reject(messages.get('serviceResponseFailure'));
            }

            var deferred = $q.defer(),
                settings = settings || {}; /* NOSONAR */

            // Prepare data
            var prepareData = {
                loginUserName: data.username,
                loginPassword: data.password,
                TargetUrl: data.targetUrl,
                isHealthcareProvider: data.isHealthcareProviderValue ? 'true' : 'false',
                rememberme: data.rememberme ? 'on' : 'off',
                isSSOEnable: data.isSSOEnable,
                client_name: 'formClient',
                organizationPathName: selectedOrg
            };

            // Send the request
            $.ajax({
                async: (settings.async === false) ? false : true,
                contentType: 'application/json',
                dataType: 'text',
                data: JSON.stringify(prepareData),
                type: 'post',
                url: LOGIN_URL,
                success: success,
                error: error
            });

            function success(data) {
                $log.log('Success: loginApi: POST "' + LOGIN_URL + '"');
                deferred.resolve(data);
            }

            function error(jqXHR) {
                if (jqXHR.statusText === "Unauthorized" || jqXHR.status === 401) {
                    var errorMsg = messages.get('custom.invalid.username.password');
                    $log.error('Error: loginApi: ' + errorMsg);
                    deferred.reject(errorMsg);
                } else {
                    deferred.reject();
                }
            }

            return deferred.promise;
        }

        function isParameterFalseOrEmpty(paramter){
            return angular.isString(paramter) === false || paramter === '';
        };

        function isParameterNotTrueAndNotFalse(parameter){
            return parameter !== true && parameter !== false;
        };

        function getCustomizeLogoInfo(orgName) {
            var deferred = $q.defer();
            var locale = window.Messages('inbox.localeCode').toLowerCase();
            var DATA_URL = "/getCustomizeLogoInfo" + "/" + orgName + "/" + locale;

            // Send the request
            $.ajax({
                async: false,
                contentType: 'application/json',
                dataType: 'text',
                type: 'get',
                url: DATA_URL,
                success: success,
                error: error,
                cache: false
            });

            return deferred.promise;

            function success() {
                $log.log('Success: loginApi getCustomizeLogoInfo');
                var res = data ? JSON.parse(data).result : [];
                clearSession().then(function() {
                    deferred.resolve(angular.copy(res));
                });
            }

            function error(jqXHR) {
                var errorMsg = JSON.parse(jqXHR.responseText).message;
                $log.error('Error: loginApi getCustomizeLogoInfo: ' + errorMsg);
                deferred.reject(errorMsg);
            }
        }

        function clearSession() {
            var deferred = $q.defer();

            $.ajax({
                async: false,
                type: 'delete',
                url: '/session',
                success: function() {
                    console.log("Session has been successfully cleared");
                    deferred.resolve();
                },
                error: function() {
                    console.log("Could not clear session");
                    deferred.reject();
                }
            });

            return deferred.promise;
        }

        function getUserData(email) {
            var deferred = $q.defer();

            var DATA_URL = GET_USERDETAILS_URL + "?email=" + email;

            // Send the request
            $.ajax({
                async: false,
                contentType: 'application/json',
                headers: {"Authorization": "Bearer " + sessionStorage.getItem('cIdToken')},
                dataType: 'text',
                //data: JSON.stringify(data),
                type: 'get',
                url: DATA_URL,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                $log.log('Success: loginApi: POST "' + LOGIN_URL + '"');
                deferred.resolve(jqXHR.status);
            }

            function error(jqXHR) {
                var errorMsg = JSON.parse(jqXHR.responseText).message;
                $log.error('Error: loginApi: ' + errorMsg);
                deferred.reject(errorMsg);
            }
        }

        function applicationLogout() {
            var deferred = $q.defer();
            url = '/logout';

            // send the request
            $.ajax({
                async: true,
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: logout: GET "' + url + '"');
                var roles = data || [];
                deferred.resolve(angular.copy(roles));
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: logout: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(messages.get('serviceResponseFailure'));
            }
        }

        function getSSOEnable() {
            var deferred = $q.defer();
            var url = '/ssoDetails';

            // send the request
            $.ajax({
                async: true,
                dataType: 'text',
                type: 'get',
                url: url,
                success: success,
                error: error,
                cache: false
            });

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                $log.log('Success: getSSOEnable: GET "' + url + '"');
                var flag = jqXHR.status || [];
                deferred.resolve(angular.copy(flag));
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: getSSOEnable: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(messages.get('serviceResponseFailure'));
            }
        }

        function isSecondFactAuthEnabled(email) {
            var deferred = $q.defer();
            var url = '/isSecondFactAuthEnabled' + '/' + encodeURIComponent(email);
            // send the request
            $.ajax({
                async: true,
                dataType: 'text',
                type: 'get',
                url: url,
                headers: {"Authorization": "Bearer " + sessionStorage.getItem('cIdToken')},
                success: success,
                error: error,
                cache: false
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: isSecondFactAuthEnabled: GET "' + url + '"');
                var flag = JSON.parse(data) || [];
                deferred.resolve(angular.copy(flag));
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: isSecondFactAuthEnabled: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(messages.get('serviceResponseFailure'));
            }
        }

        function getOrganizationNameFromSession() {
            var deferred = $q.defer();

            $.ajax({
                async: false,
                dataType: 'json',
                type: 'get',
                url: '/session/organizationName',
                data: {
                    '_': Date.now().toString()
                },
                success: function (response) {
                    selectedOrg = response['orgName'];
                    deferred.resolve(response['orgName']);
                },
                error: function () {
                    console.log("Could not get organization from session");
                    deferred.reject();
                }
            });

            return deferred.promise;
        }


    }]);

});

